/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * * `BASIC_INFO` - The Basics
 * * `RATES` - Shift Details
 * * `PROFESSIONAL_TRAITS` - Professional Details
 * * `SIGN_AGREEMENT` - Marketplace Agreement
 */
export enum ProviderCompletedRegistrationStepsEnum {
    BASIC_INFO = 'BASIC_INFO',
    RATES = 'RATES',
    PROFESSIONAL_TRAITS = 'PROFESSIONAL_TRAITS',
    SIGN_AGREEMENT = 'SIGN_AGREEMENT',
}
